import { useTranslation } from 'react-i18next';

import { ConnectionFallback } from '../ConnectionFallback';

interface ConnectToMessengerProps {
  description: string;
  to: string;
}
export const ConnectToMessenger = ({ to, description }: ConnectToMessengerProps) => {
  const { t } = useTranslation('anychat');

  return (
    <ConnectionFallback
      imgSrc="/assets/anychat/connect-anychat.png"
      imgAlt={t('anychat.shared.connectToMessenger.alt')}
      title={t('anychat.shared.connectToMessenger.title')}
      description={description}
      link={to}
      linkLabel={t('anychat.shared.connectToMessenger.link')}
    />
  );
};
